/**
 * Theme Provider Wrapper
 * Combines React Context and Material-UI ThemeProvider
 */

import React, { useContext } from 'react';
import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles';
import ThemeContext, { ThemeProvider as ReactThemeContext } from './ThemeContext';
import { createMuiTheme } from './createTheme';

// Inner provider that handles MUI theme
const InnerThemeProvider = ({ children }) => {
  const { theme } = useContext(ThemeContext);
  const muiTheme = createMuiTheme(theme);

  return <MuiThemeProvider theme={muiTheme}>{children}</MuiThemeProvider>;
};

// Combined provider
export const AppThemeProvider = ({ children }) => {
  return (
    <ReactThemeContext>
      <InnerThemeProvider>{children}</InnerThemeProvider>
    </ReactThemeContext>
  );
};

export default AppThemeProvider;
